import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { di } from 'react-magnetic-di';
import { useUIModificationsConsentStatusForApps } from '../../adjustments-context/hooks/use-consent-status';
import { UIM_CONSENT_REQUIRED } from '../../adjustments-context/types';
import { useFieldIsProcessing } from '../../issue-adjustments/hooks/use-field-is-processing';

/**
 * Hook covers the blocking (loading) UIM functionality:
 * - when UIM error occurred @see `useFieldIsProcessing` it returns false - fields are NOT blocked
 * - scenarios with consent and registering fields: see unit tests.
 */
export var useFieldIsBusy = function useFieldIsBusy(fieldId) {
  var _useFieldIsProcessing = useFieldIsProcessing(fieldId),
    _useFieldIsProcessing2 = _slicedToArray(_useFieldIsProcessing, 1),
    isBusyData = _useFieldIsProcessing2[0];
  var uimConsentMap = useUIModificationsConsentStatusForApps();
  var isBusy = isBusyData.isBusy,
    appsIds = isBusyData.appsIds;
  if (!isBusy) {
    return false;
  }
  return appsIds.some(function (appId) {
    return uimConsentMap[appId] !== UIM_CONSENT_REQUIRED;
  });
};